import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "evil-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('roles.mordred')) + " " + _toDisplayString(_ctx.$t('roles.role')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "mordred" }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('mordred.generalInformation')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "mordred.playingAsMordred" })
    ]),
    _createVNode(_component_TopRolePlayer, {
      role: "mordred",
      class: "my-4"
    }),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('mordred.generalTips')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('mordred.hiddenIdentity')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "mordred.hiddenIdentityContent" })
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('mordred.distrust')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('mordred.distrustContent')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('mordred.coordinateMinions')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('mordred.coordinateMinionsContent')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('mordred.leadShadows')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('mordred.leadShadowsContent')), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('mordred.protectIdentity')), 1),
        _createVNode(_component_LocalizedTextWrapper, { keypath: "mordred.protectIdentityContent" })
      ])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "mordred.commandTheShadows" })
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}